module.exports = __webpack_public_path__ + "img/4.4cd8b2ff.png";